import { render, staticRenderFns } from "./JapaneseForm.vue?vue&type=template&id=75a6016a&scoped=true&"
import script from "./JapaneseForm.vue?vue&type=script&lang=js&"
export * from "./JapaneseForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75a6016a",
  null
  
)

export default component.exports